<div class="panel__content">
  <div class="textfield--float-label">
    <!-- Begin hosted fields section -->
    <label class="hosted-field--label" for="card-number">
      <mat-icon aria-hidden="false" aria-label="credit-card-number" fontIcon="credit_card" class="icon-small"></mat-icon>                     
      <span>Card Number</span>
    </label>
    <div id="card-number" class="hosted-field"></div>
    <!-- End hosted fields section -->
  </div>

  <div class="textfield--float-label">
    <!-- Begin hosted fields section -->
    <label class="hosted-field--label" for="expiration-date">
      <mat-icon aria-hidden="false" aria-label="card holder name" fontIcon="event" class="icon-small"></mat-icon>                     
      <span>Expiration Date</span>
    </label>
    <div id="expiration-date" class="hosted-field"></div>
    <!-- End hosted fields section -->
  </div>

  <div class="textfield--float-label">
    <!-- Begin hosted fields section -->
    <label class="hosted-field--label" for="cvv">
      <mat-icon aria-hidden="false" aria-label="card holder name" fontIcon="pin" class="icon-small"></mat-icon>                     
      <span>CVV</span>
    </label>
    <div id="cvv" class="hosted-field"></div>
    <!-- End hosted fields section -->
  </div>

  <div class="textfield--float-label">
    <label class="hosted-field--label" for="cardholder-name" name="card-holder-name">
      <mat-icon aria-hidden="false" aria-label="card holder name" fontIcon="person" class="icon-small"></mat-icon>                     
      <span>Cardholder's Name</span>
    </label>
    <div id="card-holder-name" class="hosted-field"></div>
  </div>

  <div class="textfield--float-label">
    <label class="hosted-field--label" for="cardholder-name" name="zip-code">
      <mat-icon aria-hidden="false" aria-label="card holder name" fontIcon="person" class="icon-small"></mat-icon>                     
      <span>Zip code</span>
    </label>
    <div id="zip-code" class="hosted-field"></div>
  </div>

  <button mat-raised-button (click)="tokenizeUserDetails();" class="pay-button" [disabled]="disablePayButton || paying()">{{data.overrideButtonLabel || 'Pay'}}</button>
  <button mat-raised-button [mat-dialog-close]="false" class="pay-button" [disabled]="paying()">Cancel</button>

</div>